module.exports = "<span>\n    {{getValue()}}\n</span>"


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/app/contents/contents.component.html
// module id = ../../../../../src/app/contents/contents.component.html
// module chunks = main